import { hydra } from '@tpluscode/rdf-ns-builders';
import { TemplateExpander } from "./TemplateExpander.mjs";
export function IriTemplateExMixin(base) {
  class IriTemplateExClass extends base {
    expand(first, ...rest) {
      return new TemplateExpander(this).expand(first, ...rest);
    }

  }

  return IriTemplateExClass;
}
IriTemplateExMixin.appliesTo = hydra.IriTemplate;